import { render, staticRenderFns } from "./vehicles-overview.vue?vue&type=template&id=0c2d0db4"
import script from "./vehicles-overview.vue?vue&type=script&lang=js"
export * from "./vehicles-overview.vue?vue&type=script&lang=js"
import style0 from "./vehicles-overview.vue?vue&type=style&index=0&id=0c2d0db4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports